import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}



const routes = [
  //pc
  {
    path: '',
    name: 'Index',
    component: () =>
      import('@/views/index/home.vue')
  },
  {
    path: '/',
    component: () =>
      import('@/views/index/home.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () =>
      import('@/views/index/home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import('@/views/login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () =>
      import('@/views/register.vue')
  },
  {
    path: '/eduActivity',
    name: 'EduActivity',
    component: () =>
      import('@/views/eduActivity/index.vue'),
    redirect: { name: 'EduList' },
    children: [
      {
        path: 'eduList',
        name: 'EduList',
        component: () =>
          import('@/views/eduActivity/eduList.vue'),
      },
      {
        path: 'eduInfo',
        name: 'EduInform',
        component: () =>
          import('@/views/eduActivity/info.vue'),
      },
      {
        path: 'info',
        name: 'EduInfo',
        component: () =>
          import('@/views/eduActivity/inform.vue'),
      },
      {
        path: 'add',
        name: 'EduAdd',
        component: () =>
          import('@/views/eduActivity/add.vue'),
      },
      {
        path: 'pxadd',
        name: 'PxAdd',
        component: () =>
          import('@/views/eduActivity/pxadd.vue'),
      },
      {
        path: 'rmadd',
        name: 'RmAdd',
        component: () =>
          import('@/views/eduActivity/rmadd.vue'),
      },
      {
        path: 'hint',
        name: 'EduHint',
        component: () =>
          import('@/views/eduActivity/hint.vue'),
      },
    ]

  },
  {
    path: '/consult',
    name: 'Consult',
    component: () =>
      import('@/views/consult/index.vue'),
    redirect: { name: 'ConsultInfo' },
    children: [
      {
        path: 'consultInfo',
        name: 'ConsultInfo',
        component: () =>
          import('@/views/consult/consult.vue'),
      },
      {
        path: 'questionList',
        name: 'ConsultQuestion',
        component: () =>
          import('@/views/consult/questionList.vue'),
      },
      {
        path: 'questionnaire',
        name: 'Questionnaire',
        component: () =>
          import('@/views/consult/questionnaire.vue'),
      }
    ]
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () =>
      import('@/views/knowledge/index.vue'),
    redirect: { name: 'KnowList' },
    children: [
      {
        path: 'knowList',
        name: 'KnowList',
        component: () =>
          import('@/views/knowledge/knowList.vue'),
      },
      {
        path: 'detail',
        name: 'NavigationDetail',
        component: () =>
          import('@/views/knowledge/detail.vue'),
      },
      {
        path: 'techDetail',
        name: 'TechDetail',
        component: () =>
          import('@/views/knowledge/techDetail.vue'),
      },
      {
        path: 'knowAudio',
        name: 'KnowAudio',
        component: () =>
          import('@/views/knowledge/audio.vue'),
      },
    ]
  },
  // {
  //   path: '/knowDetail',
  //   name: 'KnowDetail',
  //   component: () =>
  //     import('@/views/knowledge/detail.vue')
  // },
  {
    path: '/navigation',
    name: 'Navigation',
    component: () =>
      import('@/views/navigation/index.vue'),
    redirect: { name: 'NavigationInfo' },
    children: [
      {
        path: 'navigationInfo',
        name: 'NavigationInfo',
        component: () =>
          import('@/views/navigation/navigation.vue'),
      },
      {
        path: 'tempList',
        name: 'TempList',
        component: () =>
          import('@/views/navigation/tempList.vue'),
      },
      {
        path: 'tempDetail',
        name: 'TempDetail',
        component: () =>
          import('@/views/navigation/tempDetail.vue'),
      },
      {
        path: 'commonList',
        name: 'CommonList',
        component: () =>
          import('@/views/navigation/commonList.vue'),
      },
      {
        path: 'commonDetail',
        name: 'CommonDetail',
        component: () =>
          import('@/views/navigation/commonDetail.vue'),
      },
      {
        path: 'commonMore',
        name: 'CommonMore',
        component: () =>
          import('@/views/navigation/commonMore.vue'),
      },
      {
        path: 'specialList',
        name: 'SpecialList',
        component: () =>
          import('@/views/navigation/specialList.vue'),
      },
      {
        path: 'specialDetail',
        name: 'SpecialDetail',
        component: () =>
          import('@/views/navigation/specialDetail.vue'),
      },
    ]
  },
  {
    path: '/information',
    name: 'Information',
    component: () =>
      import('@/views/information/index.vue'),
    redirect: { name: 'InfoList' },
    children: [
      {
        path: 'infoList',
        name: 'InfoList',
        component: () =>
          import('@/views/information/infoList.vue'),
      },
      {
        path: 'infoDetail',
        name: 'InformationDetail',
        component: () =>
          import('@/views/information/detail.vue'),
      }
    ]
  },
  {
    path: '/partyInfo',
    name: 'PartyInfo',
    component: () =>
      import('@/views/partyInfo/index.vue'),
    redirect: { name: 'PartyList' },
    children: [
      {
        path: 'partyList',
        name: 'PartyList',
        component: () =>
          import('@/views/partyInfo/infoList.vue'),
      },
      {
        path: 'partyDetail',
        name: 'PartyDetail',
        component: () =>
          import('@/views/partyInfo/detail.vue'),
      }
    ]
  },
  {
    path: '/personCenter',
    name: 'PersonCenter',
    component: () =>
      import('@/views/personCenter/index.vue'),
    redirect: { name: 'PersonInfo' },
    children: [
      {
        path: 'personInfo',
        name: 'PersonInfo',
        component: () =>
          import('@/views/personCenter/personInfo.vue'),
      },
      {
        path: 'account',
        name: 'Account',
        component: () =>
          import('@/views/personCenter/account.vue'),
      },
      {
        path: 'volunteer',
        name: 'PersonVolunteer',
        component: () =>
          import('@/views/personCenter/personvolunteer.vue'),
      }
    ]
  },
  {
    path: '/overview',
    name: 'Overview',
    component: () =>
      import('@/views/overview/index.vue'),
    redirect: { name: 'OverviewInfo' },
    children: [
      {
        path: 'overviewInfo',
        name: 'OverviewInfo',
        component: () =>
          import('@/views/overview/overview.vue'),
      },
      {
        path: 'overviewDetail',
        name: 'OverviewDetail',
        component: () =>
          import('@/views/overview/detail.vue'),
      },
    ]
  },
  {
    path: '/cinema',
    name: 'Cinema',
    component: () =>
      import('@/views/cinema/index.vue'),
    redirect: { name: 'CinemaInfo' },
    children: [
      {
        path: 'inform',
        name: 'CinemaInfo',
        component: () =>
          import('@/views/cinema/inform.vue'),
      },
      {
        path: 'purchase',
        name: 'CinemaPurchase',
        component: () =>
          import('@/views/cinema/purchase.vue'),
      }
    ]

  },
  {
    path: '/teenager',
    name: 'Teenager',
    component: () =>
      import('@/views/teenager/index.vue'),
    redirect: { name: 'TeenagerInfo' },
    children: [
      {
        path: 'teenagerInfo',
        name: 'TeenagerInfo',
        component: () =>
          import('@/views/teenager/teenager.vue'),
      },
      {

        path: 'noticelist',
        name: 'NoticeList',
        component: () =>
          import('@/views/teenager/noticelist.vue'),
      },
      {

        path: 'noticedetail',
        name: 'NoticeDetail',
        component: () =>
          import('@/views/teenager/noticedetail.vue'),
      },
      {
        path: 'newslist',
        name: 'NewsList',
        component: () =>
          import('@/views/teenager/newslist.vue'),
      },
      {
        path: 'newsdetail',
        name: 'NewsDetail',
        component: () =>
          import('@/views/teenager/newsdetail.vue'),
      },
      {
        path: 'workslist',
        name: 'WorksList',
        component: () =>
          import('@/views/teenager/workslist.vue'),
      },
      {
        path: 'worksdetail',
        name: 'WorksDetail',
        component: () =>
          import('@/views/teenager/worksdetail.vue'),
      },
      {
        path: 'materiallist',
        name: 'MaterialList',
        component: () =>
          import('@/views/teenager/materiallist.vue'),
      }
    ]
  },
  {
    path: '/museum',
    name: 'Museum',
    component: () =>
      import('@/views/museum/index.vue'),
    redirect: { name: 'MuseumInfo' },
    children: [
      {
        path: 'museumInfo',
        name: 'MuseumInfo',
        component: () =>
          import('@/views/museum/museum.vue'),
      },
      {
        path: 'museumnewslist',
        name: 'MuseumNewsList',
        component: () =>
          import('@/views/museum/newslist.vue'),
      },
      {
        path: 'museumnewsdetail',
        name: 'MuseumNewsDetail',
        component: () =>
          import('@/views/museum/newsdetail.vue'),
      },
      {
        path: 'apply',
        name: 'Apply',
        component: () =>
          import('@/views/museum/apply.vue'),
      }
    ]
  },
  {
    path: '/cinemaTicket',
    name: 'CinemaTicket',
    component: () =>
      import('@/views/cinema/index.vue')
  },
  {
    path: '/selfAppoint',
    name: 'Self',
    component: () =>
      import('@/views/selfAppoint/index.vue'),
    redirect: { name: 'SelfInfo' },
    children: [
      {
        path: 'info',
        name: 'SelfInfo',
        component: () =>
          import('@/views/selfAppoint/info.vue'),
      },
      {
        path: 'selfAppoint',
        name: 'SelfAppoint',
        component: () =>
          import('@/views/selfAppoint/appoint.vue'),
      },
      {
        path: 'selfAdd',
        name: 'SelfAdd',
        component: () =>
          import('@/views/selfAppoint/add.vue'),
      },
      {
        path: 'selfHint',
        name: 'SelfHint',
        component: () =>
          import('@/views/selfAppoint/hint.vue'),
      }
    ]
  },
  {
    path: '/team',
    name: 'Team',
    component: () =>
      import('@/views/teamAppoint/index.vue'),
    redirect: { name: 'TeamInfo' },
    children: [
      {
        path: 'info',
        name: 'TeamInfo',
        component: () =>
          import('@/views/teamAppoint/info.vue'),
      },
      {
        path: 'teamAppoint',
        name: 'TeamAppoint',
        component: () =>
          import('@/views/teamAppoint/appoint.vue'),
      },
      {
        path: 'teamAdd',
        name: 'TeamAdd',
        component: () =>
          import('@/views/teamAppoint/add.vue'),
      },
      {
        path: 'teamHint',
        name: 'TeamHint',
        component: () =>
          import('@/views/teamAppoint/hint.vue'),
      }
    ]

  },
  {
    path: '/volunteer',
    name: 'Volunteer',
    component: () =>
      import('@/views/volunteer/index.vue'),
    redirect: { name: 'VolunteerInfo' },
    children: [
      {
        path: 'info',
        name: 'VolunteerInfo',
        component: () =>
          import('@/views/volunteer/info.vue'),
      },
      {
        path: 'volunteerAppoint',
        name: 'VolunteerAppoint',
        component: () =>
          import('@/views/volunteer/appoint.vue'),
      },
      {
        path: 'volunteerAdd',
        name: 'VolunteerAdd',
        component: () =>
          import('@/views/volunteer/add.vue'),
      },
      {
        path: 'volunteerHint',
        name: 'VolunteerHint',
        component: () =>
          import('@/views/volunteer/hint.vue'),
      }
    ]

  },
  {
    path: '/search',
    name: 'Search',
    component: () =>
      import('@/views/search/index.vue'),
    redirect: { name: 'SearchInfo' },
    children: [
      {
        path: 'searchInfo',
        name: 'SearchInfo',
        component: () =>
          import('@/views/search/info.vue'),
      }
    ]

  },
  {
    path: '/test',
    name: 'Test',
    component: () =>
      import('@/views/text.vue')
  },
  {
    path: '/member',
    name: 'Member',
    component: () =>
      import('@/views/member/index.vue'),
    redirect: { name: 'Member' },
    children: [{
      path: 'outperiod',
      name: 'Outperiod',
      component: () =>
        import('@/views/member/components/outperiod.vue')
    }, {
      path: 'member',
      name: 'Member',
      component: () =>
        import('@/views/member/components/buyMember.vue')
    }, {
      path: 'memberMall',
      name: 'MemberMall',
      component: () =>
        import('@/views/member/components/memberMall.vue')
    }, {
      path: 'memberMallDetail',
      name: 'MemberMallDetail',
      component: () =>
        import('@/views/member/components/memberMallDetail.vue')
    }, {
      path: 'memberWelfare',
      name: 'MemberWelfare',
      component: () =>
        import('@/views/member/components/memberWelfare.vue')
    }, {
      path: 'memberWelfareDetail',
      name: 'MemberWelfareDetail',
      component: () =>
        import('@/views/member/components/memberWelfareDetail.vue')
    }, {
      path: 'memberOrder',
      name: 'MemberOrder',
      component: () =>
        import('@/views/member/components/memberOrder.vue')
    }, {
      path: 'memberOrderDetail',
      name: 'MemberOrderDetail',
      component: () =>
        import('@/views/member/components/memberOrderDetail.vue')
    }, {
      path: 'memberIntegral',
      name: 'MemberIntegral',
      component: () =>
        import('@/views/member/components/memberIntegral.vue')
    }]
  }
]




const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js